import React, { ReactElement } from 'react'
import { PageSeo } from '@/components/NextSeo/PageSeo'
import { UiLayoutConstant } from '@/globals/uiLayoutConstant'
import { CourseConfigType } from 'common/src/courseConfig'
import { GetStaticProps } from 'next'
import { getAvailableCourseTracks } from '@/components/sharedFetchStaticProps/getAvailableCourseTracks'
import { CourseInfo } from 'common/src/api/core/courses/types'
import { CoursesPage } from '@/components/Courses/CoursesPage'

export const getStaticProps = (async (_context) => {
    const courseConfigType = CourseConfigType.fsaHealth
    const response = await getAvailableCourseTracks(courseConfigType)
    return { props: { ...response, courseConfigType } }
}) satisfies GetStaticProps<{
    coursesInfo: CourseInfo[]
    courseConfigType: CourseConfigType
}>

const Page = (props: {
    coursesInfo: CourseInfo[]
    courseConfigType: CourseConfigType
}): ReactElement => {
    return (
        <>
            <PageSeo
                title={'FSA Health & Life exam courses and pricing'}
                description={
                    'Every Just Enough Prep FSA Health & Life course: comprehensive outlines, notecards and exam-style questions, autograding, and Eupheus your AI study partner. Compare exams and plans.'
                }
                canonicalPath={UiLayoutConstant.COURSES_PAGE}
            />
            <CoursesPage
                {...props}
                isLoggedIn={false}
                userPaymentHistory={null}
                demoHistory={null}
                setUserInfo={null}
                courseName={null}
            />
        </>
    )
}

Page.isStatic = true

export default Page
